import { makeStyles } from '@material-ui/core/styles'

// Styles
export const useStyles = makeStyles((theme) => ({
  root: {
    width: '300px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  dropDownMenu: {
    padding: 0
  },
  accordionDetail: {
    display: 'block'
  },
  listRoot: {
    paddingTop: 0,
    paddingBottom: 0
  },
  noAccordion: {
    display: 'flex',
    padding: '0px 16px',
    minHeight: 48
  },
  noAccordionHeading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    margin: '12px 0',
    display: 'flex',
    flexGrow: 1
  }
}))